import { type ClassValue, clsx } from "clsx";
import type { ForwardedRef, RefCallback, RefObject } from "react";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Sets multiple refs on a single element.
 *
 * @param refs
 * @returns
 */
export function setRefs<T>(
  ...refs: Array<ForwardedRef<T | null> | RefObject<T | null> | undefined>
): RefCallback<T | null> {
  return (node: T | null) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    });
  };
}

export function isInputDOMNode(event: KeyboardEvent): boolean {
  const inputTags = new Set(["INPUT", "SELECT", "TEXTAREA"]);

  // using composed path for handling shadow dom
  const target = (event.composedPath?.()?.[0] || event.target) as Element | null;
  if (target?.nodeType !== 1 /* Node.ELEMENT_NODE */) {
    return false;
  }

  const isInput = inputTags.has(target.nodeName) || target.hasAttribute("contenteditable");

  return isInput;
}
